import React, { useEffect, useState } from 'react';
import { Alert, Button, ButtonGroup, Checkbox, FormControl, FormControlLabel, Grid, Radio, TextField, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

import InputCreateHtml from './InputCreateHtml';
import { useFormContext } from 'react-hook-form';
import { FormDropZone, GroupRadioButtonForm, ModalGeneral, TextFieldNumber, VisorPDF } from 'ui-component';
import { BigPlayButton, ControlBar, VolumeMenuButton, Player } from 'video-react';
import { colors } from '@mui/material';
import { Delete, CloudDownload, PictureAsPdf } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';
import InputLink from './enlancesView';
import EnlacePreview from './EnlacePreview';
import ServiciosPlantilla from '../../../Configuracion/Plantillas/Components/ServiciosPlantilla';

const useStyles = makeStyles((theme) => ({
    helperTextError: {
        color: colors.red[500],
        marginLeft: '14px',
        marginRight: '14px',
        marginTop: '4px',
        fontSize: '0.75rem',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
    },
    helperText: {
        color: 'black',
        marginLeft: '0px',
        marginRight: '14px',
        marginTop: '4px',
        fontSize: '1rem',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
    },
    helperText2: {
        color: colors.grey[500],
        marginLeft: '14px',
        marginRight: '14px',
        marginTop: '4px',
        fontSize: '0.75rem',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
    }
}));

const TIPOS_PERIODO_ABAJO = [3, 7, 10, 11, 12];

const TIPOS_DIAS_OBLIGATORIO = [];

const diasHabilitarValido = (valor) => (Number(valor) > 0 ? valor : '');

const FormDetalleActividad = ({ open, isAdd, data, ctl, isVer, soloEditablePeriodo = false, ...props }) => {
    const classes = useStyles();
    const serviciosPlantilla = ServiciosPlantilla();
    const [modal, setModal] = useState({ open: false, titulo: '' });
    const [habilitarPeriodo, setHabilitarPeriodo] = useState(false);

    const {
        register,
        watch,
        formState: { errors },
        control,
        setValue,
        getValues,
        unregister,
        trigger,
        clearErrors
    } = useFormContext();

    const idTipoActividad = watch('idTipoActividad') === undefined ? data?.idTipoActividad : watch('idTipoActividad');
    const clickEliminarArchivoActivo = () => setValue('archivoActivo', null);
    const cerrarModal = () => setModal({ open: false });

    const [usarPlantilla, setUsarPlantilla] = useState(false);
    const [plantillasDisponibles, setPlantillasDisponibles] = useState([]);
    const [idPlantillaSeleccionada, setIdPlantillaSeleccionada] = useState('');

    const plantillaSeleccionadaObj = plantillasDisponibles.find((p) => String(p.idPlantilla) === String(idPlantillaSeleccionada));

    const ocultarPorPlantilla = Number(idTipoActividad) === 12 && usarPlantilla;

    const abrirPDF = () => {
        setModal({
            open: true,
            formulario: VisorPDF,
            propsModal: {
                isBase64: true,
                data: data,
                title: 'PDF actividad' + data?.titulo
            }
        });
    };

    const descargarArchivo = () => {
        window.open(data?.linkVideo, '_blank', 'noreferrer');
    };

    const handleTogglePeriodo = (e) => {
        const checked = e.target.checked;
        setHabilitarPeriodo(checked);
        if (checked) {
            setValue('diasHabilitar', null);
        } else {
            setValue('diaInicio', null);
            setValue('diaFin', null);
        }
    };

    const handleCambioUsarPlantilla = (event) => {
        const checked = event.target.checked;
        setUsarPlantilla(checked);
        setValue('usarPlantilla', checked ? 1 : 0);
        setValue('idPlantilla', null);
        setIdPlantillaSeleccionada('');
        clearErrors('idPlantilla');

        if (checked) {
            serviciosPlantilla.getPlantillasPorTipo((res) => setPlantillasDisponibles(res.plantillas || []), {
                idTipoActividad
            });
        } else {
            setPlantillasDisponibles([]);
        }
    };

    const handleCambioPlantilla = (event) => {
        const valor = event.target.value;
        setIdPlantillaSeleccionada(valor);
        setValue('idPlantilla', valor || null);
        if (valor) {
            clearErrors('idPlantilla');
        }
    };

    const extensionesValidasAudio = ['audio/mpeg', 'audio/wav', 'audio/ogg', 'audio/*'];

    const extensionesValidasDescargables = [
        'image/*',
        'video/*',
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'text/plain',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/xml',
        'text/xml',
        'audio/*',
        'application/zip',
        'application/x-zip-compressed'
    ];

    const extensionesNoValidas = [
        'application/x-msdownload',
        'application/javascript',
        'text/javascript',
        'application/x-msdos-program',
        'application/x-sh',
        'text/x-sh',
        'application/octet-stream',
        ''
    ];

    const dropZoneRules = {
        required: { value: true, message: 'Campo requerido' },
        validate: (value) => !extensionesNoValidas.includes(value[0]?.type) || 'Extensión no válida'
    };

    const dropZoneRulesAudio = {
        required: { value: true, message: 'Campo requerido' },
        validate: (value) => {
            const file = value?.[0]?.file;
            if (!file) return 'Archivo inválido';
            return file.type.startsWith('audio/') || file.name.match(/\.(wav|mp3|ogg)$/i) || 'Solo se permiten archivos de audio';
        }
    };

    useEffect(() => {
        if (data) {
            register('idTipoActividad');
            setValue('idTipoActividad', data?.idTipoActividad);

            register('solicitarEvidencia');
            setValue('solicitarEvidencia', data?.solicitarEvidencia);

            // Forzar el valor de título cuando el campo está deshabilitado (edición restringida por plantilla)
            if (soloEditablePeriodo) {
                register('titulo');
                setValue('titulo', data?.titulo);
            }

            if (data.diaInicio != null && data.diaFin != null) {
                setHabilitarPeriodo(true);
                setValue('diaInicio', data.diaInicio);
                setValue('diaFin', data.diaFin);
                setValue('diasHabilitar', null);
            } else {
                setHabilitarPeriodo(false);
                setValue('diaInicio', null);
                setValue('diaFin', null);
                setValue('diasHabilitar', diasHabilitarValido(data?.diasHabilitar));
            }
        } else {
            register('solicitarEvidencia');
            setValue('solicitarEvidencia', 0);
            setHabilitarPeriodo(false);
        }

        if (data && [2, 4, 5, 6, 8].includes(Number(data?.idTipoActividad))) {
            register('archivoActivo');
            setValue('archivoActivo', data?.linkVideo);
        } else unregister('archivoActivo');
    }, [data]);

    useEffect(() => {
        if (!isVer && !soloEditablePeriodo) {
            register('usarPlantilla');
            register('idPlantilla', {
                validate: (value) => {
                    const usaPlantillaActual = getValues('usarPlantilla');
                    if (usaPlantillaActual == 1 && !value) return 'Selecciona una plantilla';
                    return true;
                }
            });
            setValue('usarPlantilla', 0);
            setValue('idPlantilla', null);
        }
    }, []);

    useEffect(() => {
        if (Number(idTipoActividad) !== 12 && usarPlantilla) {
            setUsarPlantilla(false);
            setValue('usarPlantilla', 0);
            setValue('idPlantilla', null);
            setIdPlantillaSeleccionada('');
            setPlantillasDisponibles([]);
            clearErrors('idPlantilla');
        }
    }, [idTipoActividad]);

    const renderPeriodoBlock = () => (
        <>
            <Grid item xs={12}>
                <FormControlLabel
                    control={<Checkbox checked={habilitarPeriodo} onChange={handleTogglePeriodo} color="primary" />}
                    label="Habilitar por periodo de tiempo"
                />
            </Grid>

            {habilitarPeriodo && (
                <>
                    <Grid item xs={6}>
                        <TextFieldNumber
                            id="txt-dia-inicio"
                            label="Día inicio *"
                            name="diaInicio"
                            error={errors?.diaInicio?.message}
                            defaultValue={data?.diaInicio}
                            suffix=" día(s)"
                            decimalScale={0}
                            control={control}
                            rules={{
                                required: { value: true, message: 'Campo requerido' },
                                validate: (val) => Number(val) >= 1 || 'El valor mínimo es 1 (el primer día del curso)'
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextFieldNumber
                            id="txt-dia-fin"
                            label="Día fin *"
                            name="diaFin"
                            error={errors?.diaFin?.message}
                            defaultValue={data?.diaFin}
                            suffix=" día(s)"
                            decimalScale={0}
                            control={control}
                            rules={{
                                required: { value: true, message: 'Campo requerido' },
                                validate: (val) => {
                                    const inicio = Number(getValues('diaInicio'));
                                    const fin = Number(val);
                                    if (fin <= 0) return 'El valor mínimo es 1';
                                    if (fin <= inicio) return 'Día fin debe ser mayor a Día inicio';
                                    return true;
                                }
                            }}
                        />
                    </Grid>
                </>
            )}
        </>
    );

    const renderDiasHabilitar = () => {
        if (habilitarPeriodo || !idTipoActividad) return null;

        const esObligatorio = TIPOS_DIAS_OBLIGATORIO.includes(Number(idTipoActividad));

        return (
            <Grid item xs={4}>
                <TextFieldNumber
                    id="txt-num-dia-habilitar"
                    label={esObligatorio ? 'Días para liberar*' : 'Días para liberar'}
                    name="diasHabilitar"
                    decimalScale={0}
                    error={errors?.diasHabilitar?.message}
                    defaultValue={diasHabilitarValido(data?.diasHabilitar)}
                    suffix=" días"
                    control={control}
                    rules={{
                        required: esObligatorio ? { value: true, message: 'Campo requerido' } : false,
                        validate: (value) => {
                            if (!esObligatorio && (value === null || value === undefined || value === '')) return true;
                            return Number(value) > 0 || 'la cantidad mínima es 1';
                        }
                    }}
                />
            </Grid>
        );
    };

    const mostrarPeriodoAbajo = TIPOS_PERIODO_ABAJO.includes(Number(idTipoActividad)) && !ocultarPorPlantilla;
    const mostrarPeriodoArriba = idTipoActividad && !TIPOS_PERIODO_ABAJO.includes(Number(idTipoActividad)) && Number(idTipoActividad) !== 9;

    const esEncuestaSatisfaccionNueva = !isVer && !soloEditablePeriodo && !data && Number(idTipoActividad) === 12;

    return (
        <Grid container spacing={2}>
            {!isVer && (
                <>
                    {esEncuestaSatisfaccionNueva ? (
                        <Grid item xs={6}>
                            <FormControlLabel
                                control={<Checkbox id="chk-usar-plantilla" checked={usarPlantilla} onChange={handleCambioUsarPlantilla} />}
                                label="Usar plantilla"
                            />
                        </Grid>
                    ) : (
                        <Grid item xs={6}>
                            <TextField
                                id="txt-tit"
                                label="Título *"
                                size="small"
                                fullWidth
                                disabled={soloEditablePeriodo}
                                {...register('titulo', {
                                    required: { value: !soloEditablePeriodo, message: 'Campo requerido' },
                                    validate: (value) =>
                                        soloEditablePeriodo ||
                                        value.match(/(^\s+|\s+$)/g) == null ||
                                        'El inicio o el final no pueden ser espacios'
                                })}
                                error={Boolean(errors.titulo)}
                                helperText={errors.titulo?.message}
                                defaultValue={data?.titulo}
                            />
                        </Grid>
                    )}
                    <Grid item xs={6}>
                        <TextField
                            id="txt-tipo"
                            label="Tipo de material *"
                            size="small"
                            fullWidth
                            select
                            SelectProps={{ native: true }}
                            disabled={data?.idTipoActividad || soloEditablePeriodo}
                            {...register('idTipoActividad', {
                                required: { value: !data?.idTipoActividad, message: 'Campo requerido' }
                            })}
                            error={Boolean(errors.idTipoActividad)}
                            helperText={errors.idTipoActividad?.message}
                            defaultValue={data?.idTipoActividad}
                            onChange={(event) => {
                                if (soloEditablePeriodo) return;
                                setValue('idTipoActividad', event.target.value);
                                setValue('archivo', []);
                            }}
                            multiline
                        >
                            <option />
                            <option value="1">Lectura</option>
                            <option value="2">Archivo</option>
                            <option value="3">Examen</option>
                            <option value="7">Encuesta</option>
                            <option value="8">Audio</option>
                            <option value="9">Enlace</option>
                            <option value="10">Examen Completo</option>
                            <option value="11">Encuesta Completa</option>
                            <option value="12">Encuesta De Satisfacción</option>
                        </TextField>
                    </Grid>
                </>
            )}

            {esEncuestaSatisfaccionNueva && usarPlantilla && (
                <>
                    <Grid item xs={6}>
                        <TextField
                            id="txt-sel-plantilla"
                            label="Plantilla *"
                            size="small"
                            fullWidth
                            select
                            SelectProps={{ native: true }}
                            value={idPlantillaSeleccionada}
                            onChange={handleCambioPlantilla}
                            error={Boolean(errors.idPlantilla)}
                            helperText={errors.idPlantilla?.message}
                        >
                            <option value="" />
                            {plantillasDisponibles.map((p) => (
                                <option key={p.idPlantilla} value={p.idPlantilla}>
                                    {p.titulo}
                                </option>
                            ))}
                        </TextField>
                        {plantillasDisponibles.length === 0 && (
                            <Typography className={classes.helperText2}>
                                No hay plantillas registradas para este tipo de material.
                            </Typography>
                        )}
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            id="txt-tit-plantilla-preview"
                            label="Título"
                            size="small"
                            fullWidth
                            value={plantillaSeleccionadaObj?.titulo || ''}
                            InputProps={{ readOnly: true }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            id="txt-dias-plantilla-preview"
                            label="Días para liberar"
                            size="small"
                            fullWidth
                            value={
                                Number(plantillaSeleccionadaObj?.diasHabilitar) > 0
                                    ? `${plantillaSeleccionadaObj.diasHabilitar} días`
                                    : plantillaSeleccionadaObj
                                    ? 'Sin días definidos'
                                    : ''
                            }
                            InputProps={{ readOnly: true }}
                        />
                    </Grid>
                </>
            )}

            {esEncuestaSatisfaccionNueva && !usarPlantilla && (
                <Grid item xs={12}>
                    <TextField
                        id="txt-tit-encuesta-sin-plantilla"
                        label="Título *"
                        size="small"
                        fullWidth
                        {...register('titulo', {
                            required: { value: true, message: 'Campo requerido' },
                            validate: (value) => value.match(/(^\s+|\s+$)/g) == null || 'El inicio o el final no pueden ser espacios'
                        })}
                        error={Boolean(errors.titulo)}
                        helperText={errors.titulo?.message}
                        defaultValue={data?.titulo}
                    />
                </Grid>
            )}

            {Boolean(isVer) && Number(idTipoActividad) === 12 && Boolean(data?.idPlantillaOrigen) && (
                <>
                    <Grid item xs={6}>
                        <TextField
                            id="txt-tit-ver-plantilla"
                            label="Título"
                            size="small"
                            fullWidth
                            value={data?.titulo || ''}
                            InputProps={{ readOnly: true }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            id="txt-dias-ver-plantilla"
                            label={data?.diaInicio != null && data?.diaFin != null ? 'Periodo de tiempo' : 'Días para liberar'}
                            size="small"
                            fullWidth
                            value={
                                data?.diaInicio != null && data?.diaFin != null
                                    ? `Día ${data.diaInicio} al día ${data.diaFin}`
                                    : Number(data?.diasHabilitar) > 0
                                    ? `${data.diasHabilitar} días`
                                    : 'Sin días definidos'
                            }
                            InputProps={{ readOnly: true }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Alert severity="info" icon={<InfoIcon fontSize="inherit" />}>
                            Este material fue creado a partir de una plantilla.
                        </Alert>
                    </Grid>
                </>
            )}

            {idTipoActividad == 9 && (
                <>
                    <Grid item xs={12}>
                        <InputLink
                            control={control}
                            name="enlace"
                            label="Enlace del recurso"
                            defaultValue={data?.enlace}
                            hidePreview
                            disabled={soloEditablePeriodo}
                            rules={{
                                required: soloEditablePeriodo ? false : 'El enlace es requerido',
                                pattern: soloEditablePeriodo
                                    ? undefined
                                    : {
                                          value: /^https?:\/\/.+/i,
                                          message: 'Ingresa una URL válida'
                                      }
                            }}
                        />
                    </Grid>

                    {!isVer && renderPeriodoBlock()}
                    {!isVer && renderDiasHabilitar()}

                    <Grid item xs={12}>
                        <EnlacePreview name="enlace" />
                    </Grid>
                </>
            )}

            {!isVer && mostrarPeriodoArriba && renderPeriodoBlock()}
            {!isVer && mostrarPeriodoArriba && !habilitarPeriodo && renderDiasHabilitar()}
            {!isVer && [2, 4, 5, 6, 8].includes(Number(idTipoActividad)) && (
                <>
                    <Grid item xs={9}>
                        <GroupRadioButtonForm
                            id="frm-btn-evi"
                            control={control}
                            name="solicitarEvidencia"
                            label="Solicitar Evidencia"
                            defaultValue={data?.solicitarEvidencia || '0'}
                            rules={{ required: { value: true, message: 'Campo requerido' } }}
                        >
                            <FormControlLabel value="1" control={<Radio />} label="SI" disabled={soloEditablePeriodo} />
                            <FormControlLabel value="0" control={<Radio />} label="NO" disabled={soloEditablePeriodo} />
                        </GroupRadioButtonForm>
                    </Grid>

                    {[2, 4, 5, 6].includes(Number(idTipoActividad)) && (
                        <Grid item xs={6}>
                            <Typography variant="caption" color="textSecondary">
                                Se aceptan archivos ZIP, PDF, imágenes, videos, documentos Word, Excel y audio.
                            </Typography>
                        </Grid>
                    )}
                    {[8].includes(Number(idTipoActividad)) && (
                        <Grid item xs={6}>
                            <Typography variant="caption" color="textSecondary">
                                Se aceptan archivos MP3, WAV y OPUS
                            </Typography>
                        </Grid>
                    )}
                </>
            )}

            {[3, 10].includes(Number(idTipoActividad)) && (
                <>
                    <Grid item xs={4}>
                        <TextFieldNumber
                            id="txt-num-cal"
                            label="Calificación aprobatoria*"
                            name="calificacion"
                            error={errors?.calificacion?.message}
                            defaultValue={data?.calificacion}
                            control={control}
                            disabled={soloEditablePeriodo}
                            rules={{
                                required: { value: !soloEditablePeriodo, message: 'Campo requerido' }
                            }}
                        />
                    </Grid>
                    {!habilitarPeriodo && renderDiasHabilitar()}
                    <Grid item xs={4}>
                        <TextFieldNumber
                            id="txt-num-int"
                            label="Número de intentos*"
                            name="numIntentos"
                            decimalScale={0}
                            suffix=" Intentos"
                            error={errors?.numIntentos?.message}
                            defaultValue={data?.numIntentos}
                            control={control}
                            disabled={soloEditablePeriodo}
                            rules={{
                                required: { value: !soloEditablePeriodo, message: 'Campo requerido' },
                                validate: (calificacion) => soloEditablePeriodo || Number(calificacion) > 0 || 'la cantidad mínima es 1'
                            }}
                        />
                    </Grid>
                </>
            )}

            {[7, 11].includes(Number(idTipoActividad)) && !habilitarPeriodo && renderDiasHabilitar()}

            {Number(idTipoActividad) === 12 && !isVer && !habilitarPeriodo && !ocultarPorPlantilla && renderDiasHabilitar()}

            {[8].includes(Number(idTipoActividad)) &&
                (watch('archivoActivo') == null && [0, null, undefined].includes(isVer) ? (
                    <Grid item xs={12}>
                        {!soloEditablePeriodo && (
                            <FormDropZone
                                id="drp-zn-audio"
                                control={control}
                                name="archivo"
                                rules={dropZoneRulesAudio}
                                acceptedFiles={extensionesValidasAudio}
                            />
                        )}
                        <Typography className={classes.helperTextError}>{errors?.archivo?.message}</Typography>
                    </Grid>
                ) : (
                    <Grid item xs={12}>
                        {!isVer && !soloEditablePeriodo && (
                            <Button color="error" variant="contained" onClick={clickEliminarArchivoActivo}>
                                <Delete /> Eliminar audio
                            </Button>
                        )}
                        <audio controls style={{ width: '100%', marginTop: 16 }}>
                            <source src={data?.linkVideo} type="audio/mpeg" />
                            <track kind="captions" srcLang="es" label="Español" src="" />
                            Tu navegador no soporta audio.
                        </audio>
                    </Grid>
                ))}

            {[2, 5].includes(Number(idTipoActividad)) &&
                (watch('archivoActivo') == null && [0, null, undefined].includes(isVer) ? (
                    <Grid item xs={12}>
                        {!soloEditablePeriodo && (
                            <FormDropZone
                                id="drp-zn-arc"
                                control={control}
                                name="archivo"
                                rules={dropZoneRules}
                                acceptedFiles={extensionesValidasDescargables}
                            />
                        )}
                        <br />
                        <Typography className={classes.helperTextError}>{errors?.archivo?.message}</Typography>
                    </Grid>
                ) : (
                    <Grid item xs={12} container>
                        {!isVer && !soloEditablePeriodo && (
                            <Grid item xs={2}>
                                <ButtonGroup variant="contained" aria-label="outlined primary button group">
                                    <Button id="btn-err" color="error" onClick={clickEliminarArchivoActivo}>
                                        <Delete />
                                    </Button>
                                </ButtonGroup>
                            </Grid>
                        )}
                        {idTipoActividad == 2 ? (
                            <Grid item xs={12}>
                                <Player src={data?.linkVideo}>
                                    <BigPlayButton position="center" />
                                </Player>
                            </Grid>
                        ) : (
                            <Grid item xs={12}>
                                <img src={data?.linkVideo} alt="imagen actividad" width="100%" height="500px" />
                            </Grid>
                        )}
                    </Grid>
                ))}

            {idTipoActividad == 1 && (
                <Grid item xs={12}>
                    <InputCreateHtml
                        id="inp-cre-htm"
                        control={control}
                        name="lectura"
                        label="Lectura"
                        defaultValue={data?.lectura}
                        disabled={soloEditablePeriodo}
                    />
                </Grid>
            )}

            {[4, 6].includes(Number(idTipoActividad)) && (
                <>
                    {watch('archivoActivo') == null && [0, null, undefined].includes(isVer) ? (
                        <Grid item xs={12}>
                            {!soloEditablePeriodo && (
                                <FormDropZone
                                    id="drp-zn-pdf"
                                    control={control}
                                    name="archivo"
                                    rules={dropZoneRules}
                                    acceptedFiles={idTipoActividad == 4 ? ['application/pdf'] : extensionesValidasDescargables}
                                />
                            )}
                            <br />
                            <Typography className={classes.helperTextError}>{errors?.archivo?.message}</Typography>
                        </Grid>
                    ) : (
                        <Grid container spacing={2}>
                            <Grid item xs={12}></Grid>
                            {!isVer && !soloEditablePeriodo && (
                                <Grid item xs={4}>
                                    <Button id="btn-del-arc" color="error" variant="contained" onClick={clickEliminarArchivoActivo}>
                                        <Delete />
                                        Eliminar archivo
                                    </Button>
                                </Grid>
                            )}
                            <Grid item xs={soloEditablePeriodo ? 12 : 8}>
                                <Button
                                    id="btn-ver"
                                    component="label"
                                    role={undefined}
                                    variant="contained"
                                    tabIndex={-1}
                                    startIcon={idTipoActividad == 4 ? <PictureAsPdf /> : <CloudDownload />}
                                    color="primary"
                                    onClick={idTipoActividad == 4 ? abrirPDF : descargarArchivo}
                                >
                                    {idTipoActividad == 4 ? 'Abrir PDF' : 'Ver archivo'}
                                </Button>
                            </Grid>
                        </Grid>
                    )}
                </>
            )}

            {!isVer && mostrarPeriodoAbajo && renderPeriodoBlock()}

            <ModalGeneral open={modal.open} width="md" titulo={modal.titulo} OnCerrar={cerrarModal}>
                {modal.formulario && <modal.formulario {...modal.propsModal} />}
            </ModalGeneral>
        </Grid>
    );
};

export default FormDetalleActividad;
